import { useTranslation } from "react-i18next";


export default function PanelNoSettings({}: {}) {
  const { t } = useTranslation("editor-blocks-library");
  return (
    <div className="p-2 text-sm text-muted-foreground">
      {t("editorBlocksLibrary.panel.noSettings.title", "No settings available for this block.")}
    </div>
  );
}
